import React from "react";
import CartImage from '../../../assest/images/card-image/ItemAvatar11.png';
import NotifyContext from "../../../contexts/NotifyContext";
import StudentSatisfactionRecordService from "../../../services/supporter/StudentSatisfactionRecordService";
import './SatisfactionRecord.scss'
import SatisfactionRecordIState, {SatisfactionRecordIProps} from "./SatisfactionRecord.models";
import { GroupUser } from "../../../models/interfaces/management/GroupUser";
export default class SatisfactionRecord extends React.PureComponent<SatisfactionRecordIProps, SatisfactionRecordIState> {
  static contextType = NotifyContext
  studentSatisfactionRecordService: StudentSatisfactionRecordService;

  constructor (props:any) {
    super(props);
    this.studentSatisfactionRecordService = new StudentSatisfactionRecordService();
    this.state= {
      studentVoteInsertView:{
        vote: 7,
        groupUser: GroupUser.Assistant
      },
      imageSrc: 'Emoticon - 7@3x'
    }
  }

  componentDidMount () {
    this.setState({studentVoteInsertView: {groupUser: this.props.groupUser, vote: 7}})
  }

  componentDidUpdate () {
    this.renderEmoji(this.state.studentVoteInsertView.vote)
  }

  renderEmoji(value?: number){
    let src = 'Emoticon - 7@3x';

    switch (value)
      {
          case 1:
            src = "Emoticon - 1@3x";
            break;
          case 2:
            src = "Emoticon - 2@3x";
            break;
          case 3:
            src = "Emoticon - 3@3x";
            break;
          case 4:
            src = "Emoticon - 4@3x";
            break;
          case 5:
            src = "Emoticon - 5@3x";
            break;
          case 6:
            src = "Emoticon - 6@2x";
            break;
          case 7:
            src = "Emoticon - 7@3x";
            break;
          case 8:
            src = "Emoticon - 8@3x";
            break;
          case 9:
            src = "Emoticon - 9@3x";
            break;
          case 10:
            src = "Emoticon - 10@3x";
            break;
      }
      this.setState({imageSrc: src})
  }

  submitStudentVote(){
    let self = this;
    self.studentSatisfactionRecordService.saveVote({groupUser: self.state.studentVoteInsertView.groupUser, vote: self.state.studentVoteInsertView.vote / 4}).then(response => {
      if(response !== undefined)
        self.context.showNotify({ badge: "success", title: "ثبت رضایت مندی", description: "ثبت رضایت مندی با موفقیت انجام شد" });
      else 
        self.context.showNotify({ badge: "danger", title: "نا موفق", description: "رخداد خطا" });
    })
  }

  render(): React.ReactNode {
    let { imageSrc, studentVoteInsertView } = this.state;
    return (
      <>
        <div className="satisfaction-area">
          <div className="col-12">
            <div className="tk-inline">
              <div className="icon">
                <img style={{width:"64px",height:"64px"}} src={CartImage} alt=""/>
              </div>
              <div className="satisfaction-title pt-2">
                <label>‌ثبت رضایتمندی از {this.props.title} </label>
              </div>
            </div>
            <div className="col-12 tk-aling-center">
              <img src={require('../../../assest/images/emoji/'+ imageSrc +'.png')} width="138" height="138" alt="emoji"/>
            </div>
            <div className="col-12 tk-aling-center tk-padding" style={{direction:'ltr'}}>
              <label style={{fontSize:'13px'}}>با کشیدن اسلایدر به سمت چپ و راست رضایت خود از عملکرد {this.props.title} را تعیین کنید</label>
              <input className="tk-full-width" value={studentVoteInsertView.vote} type="range" min="1" max="10"  onChange={(event) => this.setState({studentVoteInsertView: {...studentVoteInsertView, vote: Number(event.target.value) }})} />
            </div>
            <div className="col-12 tk-aling-center pb-3">
              <button className="btn btn-success tk-full-width margin-top" onClick={() => this.submitStudentVote()}>ثبت رضایت مندی</button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
